import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import api from '../modules/api'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    authenticated: !!window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}access_token`),
    accessToken: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}access_token`),
    refreshToken: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}refresh_token`),
    expiresIn: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}expires_in`),
    customerId: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}customer_id`),
    organizationId: window.localStorage.getItem(`${process.env.LOCALSTORAGE_PREFIX}organization_id`),
    showErrorBubble: null,
    isError: false,
    error: {},
    customer: {},
    organization: {},
    organizations: [],
    product: {},
    products: [],
    productsTotal: 0,
    client: {},
    clients: [],
    clientsTotal: 0,
    thing: {},
    deleteThing: {},
    productThings: [],
    productThingsTotal: 0,
    file: {},
    fwUpdate: {},
    fwUpdates: [],
    fwUpdatesTotal: 0,
    clientDevices: [],
    clientDevicesTotal: 0,
    deleteFwUpdate: {},
    user: {},
    users: [],
    usersTotal: 0,
    userDevices: {},
    owners: [],
    guests: [],
    invitees: [],
    states: [],
    ownedThings: [],
    sharedThings: [],
    invitedThings: []
  },
  mutations,
  actions: actions(api)
})

// Set Authorization header on app launch (e.g. on page reload).
// Get token from the localStorage
store.dispatch('setToken', store.state.accessToken)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js